import { Controller } from "@hotwired/stimulus";
/**
 * Order Search Controller - Manages order-specific filter functionality
 */
class default_1 extends Controller {
    connect() {
        this.setupAutoSubmit();
    }
    checkboxes(event) {
        if (!event || !(event.target instanceof HTMLInputElement))
            return;
        const target = event.target;
        // Disable checkboxes accordingly for orders-specific logic
        // Now we uncheck the mutually exclusive options instead of disabling them
        if (target.checked) {
            // Status filters - mutually exclusive
            if (this.hasActiveTarget && target === this.activeTarget) {
                if (this.hasExpiredTarget)
                    this.expiredTarget.checked = false;
                if (this.hasExpiringTarget)
                    this.expiringTarget.checked = false;
            }
            else if (this.hasExpiredTarget && target === this.expiredTarget) {
                if (this.hasActiveTarget)
                    this.activeTarget.checked = false;
                if (this.hasExpiringTarget)
                    this.expiringTarget.checked = false;
            }
            else if (this.hasExpiringTarget && target === this.expiringTarget) {
                if (this.hasActiveTarget)
                    this.activeTarget.checked = false;
                if (this.hasExpiredTarget)
                    this.expiredTarget.checked = false;
            }
            // Currency filters - mutually exclusive
            if (this.hasUsdTarget && target === this.usdTarget) {
                if (this.hasBrlTarget)
                    this.brlTarget.checked = false;
            }
            else if (this.hasBrlTarget && target === this.brlTarget) {
                if (this.hasUsdTarget)
                    this.usdTarget.checked = false;
            }
            // Service filters - mutually exclusive
            if (this.hasServicesTarget && target === this.servicesTarget) {
                if (this.hasNoservicesTarget)
                    this.noservicesTarget.checked = false;
            }
            else if (this.hasNoservicesTarget && target === this.noservicesTarget) {
                if (this.hasServicesTarget)
                    this.servicesTarget.checked = false;
            }
        }
    }
    toggle(event) {
        this.checkboxes(event);
        this.element.requestSubmit();
    }
    onCustomerChange() {
        const query = this.customerTarget?.value?.trim();
        if (query && query.length < 3)
            return;
        this.envia();
    }
    resetcustomer() {
        if (this.customerTarget) {
            this.customerTarget.value = "";
            this.envia();
        }
    }
    resetendcustomer() {
        if (this.endcustomerTarget) {
            this.endcustomerTarget.value = "";
            this.envia();
        }
    }
    setupAutoSubmit() {
        // Add event listeners to all form inputs for auto-submit
        // Use 'change' event:
        // - For text inputs: fires on blur if value changed
        // - For checkboxes/selects: fires immediately on selection
        const inputs = this.element.querySelectorAll('input, select');
        inputs.forEach(input => {
            input.addEventListener('change', (event) => {
                if (input.type === 'checkbox') {
                    this.checkboxes(event);
                }
                this.envia();
            });
        });
    }
    envia() {
        ;
        this.element.requestSubmit();
    }
    disconnect() {
        // Clean up timeouts
        if (this.inputTimeout) {
            clearTimeout(this.inputTimeout);
        }
    }
}
default_1.targets = [
    'customer', 'endcustomer', 'active', 'usd', 'brl',
    'services', 'noservices', 'expired', 'expiring'
];
export default default_1;
